<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      stroke="#153D49"
      stroke-linecap="round"
      stroke-width="2"
      d="M15 1 1 15M1 1l14 14"
    />
  </svg>
</template>
